import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_LV.json';
import exercises from './PILATES_EXERCISES_LV.json';
import recipes from './PILATES_RECIPES_LV.json';

export const PILATES_DATA_LV: ServiceData = {
  articles,
  exercises,
  recipes,
};
